export const mapData = state => state.getIn(['map', 'mapData'])
export const mapDisplayMode = state => state.getIn(['map', 'displayMode'])
export const mapZoomBounds = state => state.getIn(['map', 'zoomBounds'])
